import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import WhatsappBanner from '../../../components/BannerWithCta/WhatsappBanner';
import DefaultWhatsAppCTA from '../../../components/WhatsApp/DefaultCTA';
import WabaNumberList from '../../../components/WhatsApp/WabaNumberList';
import useFBAuthenticated from '../../../hooks/useFBAuthenicated';

const WhatsApp = (props) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const { isAuthenticated } = useFBAuthenticated(access_token);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const getGreetingTime = (momentDate) => {
    let greeting = null;

    if (!momentDate || !momentDate.isValid()) {
      return;
    }

    const split_afternoon = 12;
    const split_evening = 17;
    const currentHour = parseFloat(momentDate.format('HH'));

    if (currentHour >= split_afternoon && currentHour <= split_evening) {
      greeting = 'afternoon';
    } else if (currentHour >= split_evening) {
      greeting = 'evening';
    } else {
      greeting = 'morning';
    }

    return greeting;
  };

  return (
    <div className="WhatsAppPage">
      <WhatsappBanner
        title="Get started with WhatsApp Business API"
        description={
          <>
            Integrate WhatsApp Business Platform (API) through Facebook to facilitate effortless
            customer engagement and
            <br /> support.
          </>
        }
        access_token={access_token}
        handleLoginSuccess={handleLoginSuccess}
        isLoggedIn={isLoggedIn}
        isAuthenticated={isAuthenticated}
      />
      {isLoggedIn || isAuthenticated ? <WabaNumberList /> : <DefaultWhatsAppCTA />}
    </div>
  );
};

export default WhatsApp;
